export default __webpack_public_path__ + "static/media/PHOTOBOOK DIGITAL GABRIEL ANGELINA.02c5846d.pdf";